export const name = 'builderComponent' as const
// Shared editor-configs VSM conversion experiment — ONE spec flips ALL migrated features' editor configs
// from Carmi to VSM (not per-feature). Distinct from the umbrella `specs.thunderbolt.vsm_editor`, which
// gates whether the editor VSM engine exists at all. Imported by BOTH the central Carmi exclusion
// (editorFeatures.carmi.ts) and the VSM side — never a re-typed literal; every migrated feature references
// this same shared spec value.
export const editorExperiment = 'specs.thunderbolt.vsmEditorConfigs' as const
export const BuilderComponentLoaderSymbol = Symbol('BuilderComponentLoader')
export const BuilderComponentRegistrarSymbol = Symbol('BuilderComponentRegistrar')
export const BuilderComponentStyleApiSymbol = Symbol('BuilderComponentStyleApi')
export const BuilderComponentResolverSymbol = Symbol('BuilderComponentResolver')
export const BuilderComponentWarmupDataEnricherSymbol = Symbol('BuilderComponentWarmupDataEnricher')
export const BuilderResourcesManagerSymbol = Symbol('BuilderResourcesManager')
export const CompTypeToAllDescendantsHandlerSymbol = Symbol('CompTypeToAllDescendantsHandler')
